import {AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChildren,} from "@angular/core";
import {OptionModel} from "../../../../../../models/option-model";
import {NgModel} from "@angular/forms";
import {MeterSensorModel} from "../../../../../../models/meter-sensor-model";
import {CounterSensorOptionEnum} from '../../../../../../enums/counter-sensor-option-enum';
import {CounterSensorNameEnum} from '../../../../../../enums/counter-sensor-name-enum';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {AutoSaveService} from '../../../../../../services/auto-save.service';
import {MeterSensorImpulseModel} from "../../../../../../models/meter-sensor-impulse-model";
import {DeviceDataService} from "../../../../../../services/device-data.service";
import {GatewayType, IDeviceData, isReadOnlyModuleType} from "../../../../../../interfaces/juconnGateway.response";
import {DataService} from "../../../../../../services/data.service";
import {MeterTypeEnum} from '../../../../../../models/meter-type.enum';
import {IRMeterTypeEnum} from '../../../../../../models/ir-meter-type.enum';
import {ShareService} from "../../../../../../services/share.service";
import {ValidationService} from "../../../../../../services/validation.service";
import {debounceTime} from "rxjs/operators";
import {SensorsCounterModel} from '../../../../../../models/data-models/sensors-counter-model';

@Component({
  selector: "app-install-sensors-counter",
  templateUrl: "./install-sensors-counter.component.html",
  styleUrls: ["./install-sensors-counter.component.scss"],
})
export class InstallSensorsCounterComponent implements OnInit, AfterViewInit, OnDestroy {
  public model: SensorsCounterModel;
  public gatewayId: string;

  public readonly LOW_IMAGE_QUALITY = AutoSaveService.LOW_IMAGE_QUALITY;
  protected readonly MeterTypeEnum = MeterTypeEnum;

  public irButtonsDisabledTime = 50; // seconds
  public irButtonsDisabled = false;
  public waitingForIRMeasurement = false;
  public timerForIRUpdate: Observable<{ timer: number, totalSeconds: number }>;

  private timerForIRButtonsDisabledSubject: BehaviorSubject<number> = new BehaviorSubject(null);
  public timerForIRButtonsDisabled: Observable<number> = this.timerForIRButtonsDisabledSubject.asObservable();

  @ViewChildren('key', {read: NgModel}) impulseKeyModels: QueryList<NgModel>;
  @ViewChildren('stepInUnit', {read: NgModel}) impulseStepInUnitModels: QueryList<NgModel>;
  @ViewChildren('initOffset', {read: NgModel}) impulseInitOffsetModels: QueryList<NgModel>;

  private inputSubscriptions: Subscription[] = [];
  private subscriptions: Subscription[] = [];
  @ViewChildren(NgModel) inputs: QueryList<NgModel>;


  public meterTypeOptions: OptionModel[] = [
    {value: MeterTypeEnum.Impulse, label: MeterTypeEnum.Impulse}
  ];

  public moduleOptions: OptionModel[] = [];

  public idOptions: OptionModel[] = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
  ];

  public irTypeOptions: string[] = [];

  public sensorNameOptions: OptionModel[] = [
    {value: CounterSensorOptionEnum.WATER, label: CounterSensorNameEnum.WATER},
    {value: CounterSensorOptionEnum.GAS, label: CounterSensorNameEnum.GAS},
    {value: CounterSensorOptionEnum.HEATING, label: CounterSensorNameEnum.HEATING},
    {value: CounterSensorOptionEnum.POWER, label: CounterSensorNameEnum.POWER},
  ];

  public sensorKeyOptions: OptionModel[] = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
  ];

  // public irTypeOptions: OptionModel[] = [
  //     {value: IRMeterType.HM_A_00, label: "Landis + Gyr UH50"},
  //     {value: IRMeterType.HM_B_00, label: "Engelmann S3C"},
  //     {value: IRMeterType.HM_B_01, label: "Itron Echo II"},
  // ];

  constructor(
    private deviceDataService: DeviceDataService,
    private dataService: DataService,
    private shareService: ShareService,
    public validationService: ValidationService
  ) {
    this.subscriptions.push(this.shareService.sensorsCounter$.subscribe((data) => {
      this.model = data || new SensorsCounterModel();
    }));
    this.model = this.shareService.sensorsCounter || new SensorsCounterModel();

    this.subscriptions.push(this.deviceDataService.deviceData$.subscribe(data => {
      if (data?.deviceData) {
        this.prepareModuleOptions(data.deviceData);
      }
    }));
    this.subscriptions.push(this.deviceDataService.implementedMeters$.subscribe(meters => {
      this.irTypeOptions = meters;
    }));
    this.subscriptions.push(this.shareService.gatewayId$.subscribe((id) => {
      this.gatewayId = id;
    }));
    this.gatewayId = this.shareService.getGatewayId();
    this.timerForIRUpdate = this.deviceDataService.timerForIRUpdate$;
  }

  async ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.publishModel();
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.publishModel();
        }));
      });
    });
  }

  isFixedSensor(sensor: MeterSensorModel): boolean {
    return !!sensor?.module && (this.shareService.generalGateway?.uvsModules || [])
      .some(m => m.address === sensor.module && m.uvsType === GatewayType.SM03);
  }

  onRemoveSensorBtnClicked(index: number) {
    if (this.isFixedSensor(this.model.counterSensors[index])) {
      return;
    }
    this.model.counterSensors.splice(index, 1);
    this.publishModel();
  }

  onAddSensorBtnClicked() {
    this.model.counterSensors.push(new MeterSensorModel());
    this.publishModel();
  }

  showError(model: NgModel) {
    return model.control.touched && model.control.invalid;
  }

  showImpulseError(model: NgModel) {
    return model.control.touched && model.control.invalid && model.control.errors['all-required'];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
  }

  async sendModuleConfig() {
    this.setTimerForIRButtonsDisabled();

    const irUartCfg: Map<Number, { input: number, device: string }[]> = new Map<Number, {
      input: number;
      device: string
    }[]>();

    for (let sensor of this.model.counterSensors) {
      if (sensor.meterType === MeterTypeEnum.IR && sensor.module && sensor.irType) {
        if (irUartCfg.get(sensor.module) == null) {
          irUartCfg.set(sensor.module, [])
        }
        irUartCfg.get(sensor.module).push({input: sensor.sensorId, device: sensor.irType});
      }
    }

    const modulesRequests = (this.shareService.generalGateway?.uvsModules || [])
      .filter(module => module?.uvsType && !isReadOnlyModuleType(module.uvsType))
      .flatMap(module => {
        return {
          ...module,
          type: module?.uvsType,
          irUartCfg: []
        };
      });

    for (let i = 0; i < modulesRequests.length; i++) {
      const config = irUartCfg.get(modulesRequests[i].address);
      if (config) {
        modulesRequests[i].irUartCfg = config;
      }
    }

    const response = await this.dataService.postSetConfig(this.gatewayId, modulesRequests);
  }

  async delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async getMeasurementData() {
    this.waitingForIRMeasurement = true;
    await this.deviceDataService.reloadDeviceData(true, this.model.counterSensors.filter(s => s.meterType === MeterTypeEnum.IR).length);
    this.waitingForIRMeasurement = false;
  }

  IRMetersAreValid(): boolean {
    return this.model.counterSensors.every(s => {
      return s.meterType === MeterTypeEnum.Impulse ||
        (s.meterType === MeterTypeEnum.IR &&
          s.module && s.sensorId && s.name && s.irType);
    });
  }

  hasIRMeter() {
    return this.model.counterSensors.some(s => s.meterType === MeterTypeEnum.IR);
  }

  onMeterTypeChanged(sensor: MeterSensorModel, meterType: MeterTypeEnum) {
    sensor.meterType = meterType;
    if (meterType === MeterTypeEnum.Impulse) {
      sensor.irType = null;
      sensor.impulse = new MeterSensorImpulseModel();
    } else {
      sensor.impulse = null;
    }
    sensor.module = null;
    sensor.sensorId = null;
  }

  prepareModuleOptions(deviceData: IDeviceData) {
    if (deviceData) {
      this.moduleOptions = deviceData.uvsModule.filter(m => m.moduleInfo.uvsType !== 'SM03').map((m) => {
        return {value: +m.moduleInfo.address, label: m.moduleInfo.address.toString(), moduleType: m.moduleInfo.uvsType}
      });

      if (deviceData.uvsModule.some(m => (m.moduleInfo.uvsType === GatewayType.SM02 || m.moduleInfo.uvsType === GatewayType.SM03 || m.moduleInfo.uvsType === GatewayType.SM04 || m.moduleInfo.uvsType === GatewayType.SM05)) && !this.meterTypeOptions.some(o => o.value === MeterTypeEnum.IR)) {
        this.meterTypeOptions.push({value: MeterTypeEnum.IR, label: MeterTypeEnum.IR});
      }

      for (const sensor of this.model.counterSensors) {
        const module = deviceData.uvsModule.find(m => m.moduleInfo.address === sensor.module);
        if (sensor.meterType === MeterTypeEnum.IR && module?.irUart) {
          if (sensor.irType === IRMeterTypeEnum.SML || sensor.irType === IRMeterTypeEnum.ALE3D5F || sensor.irType.toLowerCase() === IRMeterTypeEnum.SML) {
            const data = module.irUart.find(uart => uart.input === sensor.sensorId && uart.type === 'SML');
            if (data) {
              sensor.seriesNumber = (data.data as any).serverId;
              sensor.manufacturer = (data.data as any).serverId?.substring(1, 4);
              sensor.smlValue = [(data.data as any)["1-0:1.8.0*255"], (data.data as any)["1-0:2.8.0*255"], (data.data as any)["1-0:3.8.0*255"]].filter(value => value !== undefined && value !== null);
              sensor.value = +sensor.smlValue[0]
            }
          } else {
            const data = module.irUart.find(uart => uart.input === sensor.sensorId && uart.type === 'METER');
            if (data) {
              sensor.manufacturer = (data.data as any).manufacturer;
              sensor.seriesNumber = (data.data as any).serial;
              sensor.value = (data.data as any).Wh;
            }
          }
        }
        if (sensor.meterType === MeterTypeEnum.Impulse && module?.impulse?.length) {
          const value = module.impulse[sensor.sensorId - 1];
          if (value) {
            sensor.value = value;
          }
        }
      }
    }
  }

  getIdOptions(module: number, selectedId: number): OptionModel[] {
    if (selectedId != null && this.model.counterSensors.some(s => s.module === module && s.sensorId === selectedId && this.isFixedSensor(s))) {
      return [{value: selectedId, label: selectedId.toString()}];
    }
    if (module) {
      return this.idOptions.filter(id => {
        return this.model.counterSensors.every(sensor => {
          return !(sensor.module === module && sensor.sensorId === id.value && id.value !== selectedId);

        });
      });
    }
    return [];
  }


  private async setTimerForIRButtonsDisabled() {
    this.irButtonsDisabled = true;
    // enable buttons after defined seconds
    for (let i = 0; i < this.irButtonsDisabledTime; i++) {
      this.timerForIRButtonsDisabledSubject.next(i);
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    this.timerForIRButtonsDisabledSubject.next(null);
    this.irButtonsDisabled = false;
  }

  private publishModel(): void {
    this.shareService.sensorsCounter = this.model;
  }
}
